<template>
	<div class="accordion">
		<div v-for="(item, index) in items"
		     :class="{ 'card' : true, 'accordion__item' : true, 'closed': !active[index] }">
			<h3 class="accordion__title" @click.prevent="toggle(index)">{{ item.title }}</h3>
			<div class="accordion__copy" v-html="item.content" :style="{ 'height': active[index] ? 'auto' : '' }"></div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';

	export default {
		name: 'Accordion',
		props: {
			items: {
				type: Array,
				required: true,
			},
			startOpen: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			let active;

			if(this.startOpen) {
				active = new Array(this.items.length).fill(true);
			} else {
				active = [];
			}

			return {
				active,
			}
		},
		methods: {
			toggle(index) {
				Vue.set(this.active, index, !this.active[index]);
			},
			open(index) {
				Vue.set(this.active, index, true);
			},
			close(index) {
				Vue.set(this.active, index, false);
			},
		},
		watch: {
			items: {
				deep: true,
				handler(value) {
					if(this.startOpen) {
						this.active = new Array(value.length).fill(true);
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	.accordion {
		.accordion__item {
			display: block;
			text-align: left;

			.accordion__title{
				cursor: pointer;
				margin-bottom: 0;
				position: relative;
				font-size: 1.2rem;
				color: $text;
				font-weight: normal;

				&:after{
					content: "";
					position: absolute;
					height: 0;
					width: 0;
					top: 0;
					right: 0;
					bottom: 0;
					margin: auto;
					border-top: 0 solid transparent;
					border-bottom: 0.5rem solid $secondary;
					border-left: 0.4rem solid transparent;
					border-right: 0.4rem solid transparent;
				}
			}

			.accordion__copy{
				margin-top: 1rem;
			}

			+ .accordion__item{
				margin-top: 2rem;
			}

			&.closed {
				.accordion__title:after {
					border-top: 0.5rem solid $secondary;
					border-bottom: 0 solid transparent;
				}

				.accordion__copy {
					height: 0 !important;
					margin-bottom: 0;
					margin-top: 0;
					overflow: hidden;
				}
			}
		}
	}
</style>
